import Vue from "vue";
import Vuex from "vuex";

import user from "./modules/user";
import app from "./modules/app";
import classer from "./modules/classer";
import mlevel from "./modules/mlevel";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user,
        app,
        classer,
        mlevel
    }
});
